import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
*查询L1统计图形的数据
 * @param params
 */
export function getPerformanceLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/performance/level1',
        method: 'get',
        params
    })
}

/**
*查询L1列表的数据
 * @param params
 */
export function listPerformance(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/performance/list',
        method: 'get',
        params
    })
}


/**
*查询抄表录入信息的数据
 * @param params
 */
export function getParameterList(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/performance/input/list',
        method: 'get',
        params
    })
}

/**
*查询抄表录入信息的数据
 * @param params
 */
export function updateParameter(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/performance/input/input',
        method: 'post',
        data: params
    })
}
/**
* 导出excel
* @param params
*/
export function exportQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/performance/export`,
      method: 'post',
      data: params
    })
  }